import { ref, watch } from 'vue';
import { getVendorConsent, registerConsentListeners } from './consentmanager';
import { getMarketingConsent } from './cookiebot';
import cmpVendorIDs from './constants/cmpVendorIDs';

const vendor = cmpVendorIDs.MICROSOFT_LIVE_CHAT;
const isAgentAvailable = ref(false);
const isConsentGiven = ref(false);

const checkConsentStatus = () => {
  try {
    let consentStatus;
    if (window.Cookiebot) {
      consentStatus = getMarketingConsent();
    } else {
      consentStatus = getVendorConsent(vendor.id);
    }

    isConsentGiven.value = consentStatus;
    return consentStatus;
  } catch {
    isConsentGiven.value = false;
    return false;
  }
};

const toggleChatWidget = () => {
  const chatIframe = document.getElementById("Microsoft_Omnichannel_LCWidget_Chat_Iframe_Window");

  if (chatIframe) {
    const shouldShow = isConsentGiven.value && isAgentAvailable.value;

    if (shouldShow) {
      chatIframe.style.display = "block";
      chatIframe.style.visibility = "visible";
      chatIframe.style.opacity = "1";
      chatIframe.style.zIndex = "999999";
      chatIframe.style.position = "fixed";
    } else {
      chatIframe.style.display = "none";
      chatIframe.style.visibility = "hidden";
      chatIframe.style.opacity = "0";
    }
  }
};
const observeForChatWidget = () => {
  const observer = new MutationObserver((mutations) => {
    mutations.forEach((mutation) => {
      mutation.addedNodes.forEach((node) => {
        if (node.id === 'Microsoft_Omnichannel_LCWidget_Chat_Iframe_Window') {
          setTimeout(() => {
            checkConsentStatus();
            if (window.Microsoft?.Omnichannel?.LiveChatWidget?.SDK?.getAgentAvailability) {
              window.Microsoft.Omnichannel.LiveChatWidget.SDK.getAgentAvailability({
                customContext: {}
              });
            }

            toggleChatWidget();
          }, 500);

          observer.disconnect();
        }
      });
    });
  });

  observer.observe(document.body, {
    childList: true,
    subtree: true
  });
};

const checkGlobalVendorConsent = () => {
  const newConsent = window.Cookiebot ? getMarketingConsent() : getVendorConsent(vendor.id);
  isConsentGiven.value = newConsent;
  toggleChatWidget();
};

const registerGlobalConsentListeners = () => {
  const intervalId = setInterval(() => {
    if (typeof window.__cmp === 'function') {
      registerConsentListeners(checkGlobalVendorConsent);
      clearInterval(intervalId);
    }
  }, 100);

  setTimeout(() => {
    clearInterval(intervalId);
  }, 5000);
};

const checkAgentsAvailability = () => {
  checkConsentStatus();

  const handleAvailability = (e) => {
    isAgentAvailable.value = e.detail?.isAgentAvailable;
    toggleChatWidget();
  };

  window.addEventListener("lcw:getAgentAvailability", handleAvailability);

  window.addEventListener("lcw:ready", () => {
    window.Microsoft?.Omnichannel?.LiveChatWidget?.SDK?.getAgentAvailability({
      customContext: {}
    });
  });

  window.Microsoft?.Omnichannel?.LiveChatWidget?.SDK?.getAgentAvailability({
    customContext: {}
  });

  observeForChatWidget();

  if (window.cmpConsentType === 'consentmanager') {
    registerGlobalConsentListeners();
    setTimeout(() => {
      checkGlobalVendorConsent();
    }, 1000);
  }

  setTimeout(() => {
    checkConsentStatus();
    toggleChatWidget();
  }, 1000);

  setTimeout(() => {
    checkConsentStatus();
    if (window.Microsoft?.Omnichannel?.LiveChatWidget?.SDK?.getAgentAvailability) {
      window.Microsoft.Omnichannel.LiveChatWidget.SDK.getAgentAvailability({
        customContext: {}
      });
    }
    toggleChatWidget();
  }, 2000);

  setTimeout(() => {
    checkConsentStatus();
    toggleChatWidget();
  }, 3000);
};

const updateConsentStatus = (consentStatus) => {
  isConsentGiven.value = consentStatus;
  toggleChatWidget();
};

watch([isAgentAvailable, isConsentGiven], () => {
  toggleChatWidget();
});

export default checkAgentsAvailability;
export { isAgentAvailable, isConsentGiven, updateConsentStatus, checkConsentStatus };
